<template>
  <div>
    <p class="h2" v-show="titre">{{ titre }}</p>
    <p class="h3" v-show="sousTitre">{{ sousTitre }}</p>
  </div>
</template>

<script>
export default {
  name: 'titre-applis',
  props: ['titre', 'sousTitre'],
}

</script>

<style scoped>
.h2 {
  margin-top: 2rem;
  font-size: 1.35rem;
}

.h3 {
  color: #515961;
  font-size: 1.1rem;
}
</style>